import { Component, EventEmitter, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PagingOptions } from 'src/app/shared/models/paging';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActionLogService } from 'src/app/shared/services/action-log.service';
import { Organization } from 'src/app/features/organization/organization-models';
import { ActionLog, EntityType } from 'src/app/features/prices/action-log';
import { SlicePipe, CommonModule } from '@angular/common';
import { TranslateActionLogStatusEnumPipe } from '../../../../pipes/translate-action-log-status-enum.pipe';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PagerBase } from 'src/app/shared/models/pagerBase';

@Component({
  selector: 'adm-action-log',
  templateUrl: './action-log.component.html',
  styleUrls: ['./action-log.component.scss'],
  imports: [CommonModule, MatPaginatorModule, MatIconModule, MatTooltipModule, SlicePipe, TranslateActionLogStatusEnumPipe],
})
export class ActionLogComponent extends PagerBase implements OnInit {
  private actionLogService = inject(ActionLogService);
  private selectedOrganizationId: number | null = null;

  @ViewChild(MatPaginator) public paginator: MatPaginator;
  @Input() public organizations: Organization[];
  @Input() public organizationFilterEmitter: EventEmitter<number | null>;
  @Input() public entityType: EntityType;
  @Input() public entityId: number | null;
  public loading$ = new BehaviorSubject<boolean>(false);

  public actionLogCount: number;
  public currentPage: number = 0;
  public pagingOptions: PagingOptions = {
    pageSize: this.defaultModalPageSize,
    pageSizeOptions: this.modalPageSizes,
  };
  public actionLogs: ActionLog[] = [];

  private pageChanged = new EventEmitter<{ pageIndex: number; pageSize: number }>();

  ngOnInit(): void {
    this.getActionLogs(null, this.entityId);

    this.organizationFilterEmitter.subscribe((organizationId: number | null) => {
      this.selectedOrganizationId = organizationId;
      this.currentPage = 0;
      this.getActionLogs(organizationId, this.entityId);
    });
  }

  public getActionLogs(organizationId: number | null = null, entityId?: number | null) {
    this.loading$.next(true);
    this.actionLogService
      .getActionLogs(organizationId, this.pagingOptions.pageSize, this.currentPage, this.entityType, entityId)
      .subscribe({
        next: result => {
          this.actionLogCount = result.totalCount;
          this.actionLogs = result.items;
        },
      })
      .add(() => {
        this.loading$.next(false);
      });
  }

  public onPageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pagingOptions.pageSize = event.pageSize;
    this.getActionLogs(this.selectedOrganizationId, this.entityId);
    this.pageChanged.emit(event);
  }
}
